export default __webpack_public_path__ + "static/media/starbuck-giftcard.add1fd07.webp";